export const VALID_IMAGE_MIME_TYPES =
  'image/jpeg, image/gif, image/png, image/tiff';
export const TEN_MEGS = 10000000;
